import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control, Errors} from 'react-redux-form/src';
import MLabelInput from '../components/MLabelInput';
import AErrorInput from '../components/AErrorInput';
import MErrorGroupInput from '../components/MErrorGroupInput';
import shouldShowErrors from './shouldShowErrors';
import MNationalitySelect from '../components/MNationalitySelect';

/**
 * OInputFieldNationality - …
 **/
class OInputFieldNationality extends Component {
  render() {
    const {
      model,
      defaultValue,
      disabled,
      placeholder,
      validators,
      validateOn,
      asyncValidators,
      messages,
      showErrors,
      unit,
      label,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
      changeAction,
      maxLength,
    } = this.props;

    return (
      <div className="o-input-field o-input-field-select">
        <MLabelInput
          htmlFor={model}
          label={label}
          description={description}
          toolLabel={toolLabel}
          toolIcon={toolIcon}
          onPressTool={onPressTool}
          disabled={disabled}
        />
        <Control
          model={model}
          defaultValue={defaultValue}
          component={MNationalitySelect}
          validators={validators}
          validateOn={validateOn}
          asyncValidators={asyncValidators}
          placeholder={placeholder}
          withFieldValue={true}
          showErrors={showErrors} // forces rerender when a value chagne - needed
          controlProps={{
            id: model,
            disabled,
            placeholder,
          }}
          mapProps={{
            error: (props) => shouldShowErrors(showErrors, props),
          }}
          changeAction={changeAction}
        />
        <Errors
          model={model}
          messages={messages}
          wrapper={MErrorGroupInput}
          component={AErrorInput}
          show={showErrors}
        />
      </div>
    );
  }
}
OInputFieldNationality.propTypes = {
  /**
   * react-redux-form model
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
   */
  model: PropTypes.string.isRequired,
  /**
   * default value of the component
   */
  defaultValue: PropTypes.object,
  /**
   * disable the input
   */
  disabled: PropTypes.bool,
  /**
   * placeholder for input
   */
  placeholder: PropTypes.string,
  /**
   * hash with validator functions
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
   */
  validators: PropTypes.object,
  /**
   * when validation should be fired
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
   */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
   * hash with async validator functions
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
   */
  asyncValidators: PropTypes.object,
  /**
   * error messages for validatiors
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
   */
  messages: PropTypes.object,
  /**
   * when errors should be shown
   * function which gets passed the props of the form-model
   * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
   */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
   * display a unit on the right
   */
  unit: PropTypes.string,
  /**
   * label and children are the same
   */
  label: PropTypes.string,
  /**
   * description for the input
   */
  description: PropTypes.any,
  /**
   * label for the tool-button, like 'Help'
   */
  toolLabel: PropTypes.string,
  /**
   * icon for the tool button like 'question-sign'
   */
  toolIcon: PropTypes.string,
  /**
   * displays a tool button with icon and fires
   * whe it is pressed. useful to show extra help infos
   */
  onPressTool: PropTypes.func,

  /**
   * limit input length on frontend via dom node
   */
  maxLength: PropTypes.number,
};
OInputFieldNationality.defaultProps = {
  validateOn: 'blur',
  showErrors: true,
  maxLength: null,
};
export default OInputFieldNationality;

